export default {
  name: 'productTags',
  component({ tagConfig = '', configuredTags = '', maxTags = 3, initialTags = [] } = {}) {
    return {
      tagConfig,
      configuredTags,
      maxTags,
      tags: initialTags,

      init() {
        const tile = this.$el.closest('[x-product-tile-init]');
        if (tile) {
          tile.addEventListener('tile:swap-product', (e) => {
            this.tags = e.detail?.tags || [];
          });
        }
      },

      get displayTags() {
        const productTags = this.tags;
        const configured = this.configuredTags ? this.configuredTags.split(',').map(t => t.trim()).filter(Boolean) : [];

        if (!configured.length) return [];

        // Build name → display map from tagConfig (format: "name:display|name:display")
        const configMap = {};
        if (this.tagConfig) {
          this.tagConfig.split('|').forEach(pair => {
            const colonIndex = pair.indexOf(':');
            if (colonIndex === -1) return;
            const name = pair.slice(0, colonIndex).trim();
            const display = pair.slice(colonIndex + 1).trim();
            configMap[name] = display;
          });
        }

        return configured
          .filter(name => productTags.includes(name))
          .slice(0, this.maxTags)
          .map(name => ({ name, display: configMap[name] || name }));
      }
    };
  }
};
